import React, { useState } from 'react';
import DataList from './data-list.base';
import { Table } from 'antd';
import configService from '../../../utils/config';
import { Skeleton } from 'antd';
import { SkeletonList } from '../../skeleton-list/skeleton-list';
import { parseSorters } from '../../../utils/parse-sorters';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { useMedia } from '../../../hooks/media.hook';

let displaySize = configService.defaultExpandScreenSize;

const DataDisplay = ({
	data = [],
	mobileData = [],
	tableColumns,
	listItemComponent,
	renderActions,
	className,
	size = 'small',
	pagination,
	loading,
	tableLayout = 'auto',
	onLoadMore,
	onSort,
	emptyText
}: any) => {
	let pageSettings: any = {
		position: pagination?.position || 'bottom',
		pageSize: pagination?.pageSize,
		total: pagination?.total
		// current: pagination?.currentPage
	};
	if (onLoadMore) pageSettings.onChange = onLoadMore;
	if (pagination?.currentPage) pageSettings.current = pagination.currentPage;

	const [sort, setSort] = useState();

	if (useMedia(displaySize)) {
		return (
			<Table
				onChange={(pagination, filter, sorters) => {
					const sortInfo = parseSorters(sorters);

					if (JSON.stringify(sortInfo) !== JSON.stringify(sort)) {
						setSort(sortInfo);
						onSort && onSort(sortInfo);
					}
				}}
				dataSource={loading ? [] : data}
				tableLayout={'auto'}
				loading={{
					spinning: loading,
					indicator: <SkeletonList marginTop="40px" itemsCount={1} title={true} rows={1} />
				}}
				columns={tableColumns}
				// scroll={{ x: true }}
				className={className}
				size={(size as SizeType) || 'small'}
				pagination={pageSettings}
				locale={{ emptyText: emptyText }}
			/>
		);
	} else {
		return (
			<DataList
				pagination={pageSettings}
				data={mobileData.reduce((agg, data) => [...agg, ...data], [])}
				loading={loading}
				renderItem={item => {
					let actions;
					actions = renderActions ? renderActions(item) : [];
					const ListItem = listItemComponent;
					if (!Array.isArray(actions)) actions = [actions];
					return (
						<DataList.DataItem actions={actions}>
							<ListItem item={item} />
						</DataList.DataItem>
					);
				}}
			/>
		);
	}
};

export default DataDisplay;
